import { render, staticRenderFns } from "./PostInteractions.vue?vue&type=template&id=4a891dd7&scoped=true"
import script from "./PostInteractions.vue?vue&type=script&lang=js"
export * from "./PostInteractions.vue?vue&type=script&lang=js"
import style0 from "./PostInteractions.vue?vue&type=style&index=0&id=4a891dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a891dd7",
  null
  
)

export default component.exports